__webpack_require__.p = "/wp-content/plugins/IchGehWaehlenEuropawahl2024/assets/";